import { render, staticRenderFns } from "./listbenefit.vue?vue&type=template&id=60ff4af8&"
import script from "./listbenefit.vue?vue&type=script&lang=js&"
export * from "./listbenefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports